import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const notificationSettingApi = {
  getNotificationSetting: async () => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.NOTIFICATION_SETTINGS}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching Notification Setting:', error);
      throw error;
    }
  },

  createNotificationSetting: async (data) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.NOTIFICATION_SETTINGS}`, data);
      return response.data;
    } catch (error) {
      console.error('Error creating Notification Setting:', error);
      throw error;
    }
  },

  updateNotificationSetting: async (data) => {
    try {
      const response = await apiClient.put(`${API_ENDPOINTS.NOTIFICATION_SETTINGS}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating Notification Setting:', error);
      throw error;
    }
  },
};

export default notificationSettingApi;